// components/LazySection.jsx

import React, { Suspense } from "react";
import { useInView } from "react-intersection-observer";
import { Box, Skeleton } from "@mui/material";

const LazySection = ({ children }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: "300px",
  });

  return (
    <Box ref={ref}>
      {inView ? (
        <Suspense
          fallback={
            <Skeleton variant="rounded" height={200} />
          }
        >
          {children}
        </Suspense>
      ) : (
        <Skeleton variant="rounded" height={200} />
      )}
    </Box>
  );
};

export default LazySection;